var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAbout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45,
    height: 45,
    fill: "none",
    viewBox: "0 0 45 45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.6,
    d: "M16.323 38.25V10.125a3.375 3.375 0 0 1 3.375-3.375h15.524a3.375 3.375 0 0 1 3.375 3.375V38.25h3.028-25.302Zm0 0V15.895h-5.42a4.5 4.5 0 0 0-4.5 4.5V38.25H3.375h12.948Zm-4.96-7.113v-8.129m11.155-10.434v4.444a4.942 4.942 0 1 0 9.884 0v-4.445m0 25.677v-9.052c0-.622-.504-1.125-1.125-1.125h-7.634c-.621 0-1.125.503-1.125 1.125v9.052h9.884Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbout);
export default __webpack_public_path__ + "static/media/about.511f9a43d49faac86423c82947cc5d85.svg";
export { ForwardRef as ReactComponent };